var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.grid && _vm.grid.length)?_c('v-row',[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12"}},_vm._l((_vm.grid),function(node,index){return _c('m-grid-node-renderer',{key:index,attrs:{"node":node,"config":_vm.config}})}),1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }